import { MediaSlider } from './MediaSlider.js';

window.customElements.define('media-slider', MediaSlider);
